var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[(!this.$store.state.favesShown)?_c('section',[_c('Heading'),_c('exhibitor-data')],1):_c('fave-bar')],1),_c('fave-button')],1)}
var staticRenderFns = []

export { render, staticRenderFns }